module.exports = __webpack_public_path__ + "img/720.e7599894.svg";